export const componentStyles = new String(".full-background-text-and-asset-component.jsx-1ac5dfb0b46a53c2{height:650px;&.jsx-1ac5dfb0b46a53c2:not(.align-to-logo){.full-background-text-and-asset-content{padding:0 96px}}}");
componentStyles.__hash = "1ac5dfb0b46a53c2";
